module.exports = __webpack_public_path__ + "img/samples+assesments.cd85d566.png";